<template>
  <div
    class="retargeting-partner"
    :style="{ ...cssVars }"
    @click="goToPartner"
  >
    <app-asset
      class="asset"
      :class="white ? 'asset--white' : ''"
      version="v3"
      :name="assetName"
      :title="title"
      :alt="title"
    />
  </div>
</template>

<script>
import AppAsset from '@/components/common/Asset.vue';

export default {
  components: { AppAsset },
  props: {
    size: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    assetName: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: false,
    },
    link: {
      type: String,
      required: true,
    },
    white: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Number,
      default: 2,
    },
    borderRadius: {
      type: Number,
      default: 16,
    },
  },
  computed: {
    cssVars() {
      return {
        '--size': `${this.size}px`,
        '--border': `${this.border}px solid var(--white)`,
        '--border-radius': `${this.borderRadius}px`,
      };
    },
  },
  methods: {
    goToPartner() {
      window.location.href = this.link;
    },
  },
};
</script>

<style lang="scss" scoped>

.retargeting-partner {
  /* @extend .shadow; */
  display: flex;
  align-items: center;
  border-radius: var(--border-radius);
  cursor: pointer;
  overflow: auto;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.asset {
  min-width: var(--size);
  min-height: var(--size);
  max-width: var(--size);
  max-height: var(--size);
  &--white {
    filter: brightness(0) invert(1);
  }
}

</style>
